import { formatNumber } from '@progress/kendo-intl'
import { Grid, GridColumn, type GridProps } from '@progress/kendo-react-grid'
import React from 'react'
import * as R from 'remeda'

import { HStack } from '~/components/elements/HStack'
import { exists } from '~/utils'

import { type SeriesItem } from '../../utils'

import styles from './TimeSeriesTable.css'

export type TimeSeriesTableProps = {
  categories: string[]
  isPercentage?: boolean
  series: SeriesItem[]
}

export const TimeSeriesTable = ({
  categories,
  isPercentage = false,
  series,
}: TimeSeriesTableProps) => {
  const data: GridProps['data'] = React.useMemo(
    () =>
      series.map((item) => ({
        name: item.name,
        ...R.mapToObj(categories, (category, index) => {
          const value = item.data[index]

          return [
            category,
            exists(value)
              ? formatNumber(value, isPercentage ? 'p1' : 'n')
              : value,
          ]
        }),
      })),
    [categories, isPercentage, series],
  )

  return (
    <HStack className={styles.root} spacing={0}>
      <Grid data={data}>
        <GridColumn
          className={styles.name}
          field="name"
          headerClassName={styles.header}
          title=" "
          width={200}
        />

        {categories.map((category) => (
          <GridColumn
            key={category}
            className={styles.surveyGroupSurvey}
            field={category}
            headerClassName={styles.header}
            title={category}
            width={90}
          />
        ))}
      </Grid>
    </HStack>
  )
}
